import * as React         from 'react';
import { useTranslation } from 'react-i18next';

import './scss/style.scss';

const FooterContacts = function(props) {
  const { t } = useTranslation();

  const {
          contacts,
          workingHours,
        } = props;

  return (
    <div className={'contacts'}>
      <div className={'label'}>{t('client_our_contacts')}</div>
      <ul className={'phones'}>
        {contacts.PHONE?.map((item, index) => {
          return (
            <li key={index}>
              <a href={`tel:${item.value}`}>{item.value}</a>
            </li>
          );
        })}
      </ul>
      <span className={'working_hours'}>
        {t('client_workTimeTitle')}: {workingHours.FROM} – {workingHours.TO}
      </span>
      <ul className={'mail'}>
        {contacts.EMAIL?.map((item, index) => {
          return (
            <li key={index}>
              <a href={`mailto:${item.value}`}>{item.value}</a>
            </li>
          );
        })}
      </ul>
      <div className={'address'}>{contacts.ADDRESS}</div>
    </div>
  );
};

export default FooterContacts;